var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sedap-practices-table" },
    [
      _c("h3", { staticClass: "sedap-practices-table__title" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, stripe: _vm.stripe } },
        [
          _vm._l(_vm.columns, function(column) {
            return [
              column.key === "legend"
                ? _c("el-table-column", {
                    attrs: {
                      prop: column.key,
                      label: column.label,
                      width: column.width,
                      align: column.align
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", {
                                staticClass: "sedap-practices-table__legend",
                                style: { backgroundColor: scope.row.legend }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : column.key === "actions" && !_vm.onlyView
                ? _c("el-table-column", {
                    attrs: {
                      prop: column.key,
                      label: column.label,
                      width: column.width,
                      align: column.align
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "sedap-practices-table__actions",
                                  attrs: {
                                    size: "mini",
                                    type: scope.row.actions.type,
                                    disabled: scope.row.actions.disabled
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit(
                                        "onAction",
                                        _vm.tableData[scope.$index]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: scope.row.actions.icon }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : column.key !== "actions"
                ? _c("el-table-column", {
                    attrs: {
                      prop: column.key,
                      label: column.label,
                      width: column.width,
                      align: column.align
                    }
                  })
                : _vm._e()
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d826f43", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d826f43","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Tables/PracticesTable/PracticesTable.vue
// module id = null
// module chunks = 